// Mock data for Nexon Installatie & Service website

export const companyInfo = {
  name: "Nexon Installatie & Service",
  tagline: "Fitnessapparatuur verhuizen, transport & installatie in heel Nederland",
  phone: "0651929275",
  email: "info@NexonService.nl",
  location: "Heel Nederland",
  instagram: "https://www.instagram.com/nexonservice_/",
  description: "Nexon Installatie & Service is uw specialist in het transporteren, installeren en onderhouden van fitnessapparatuur. Van loopbanden tot krachttoestellen, wij zorgen ervoor dat uw gym klaar is voor gebruik."
};

export const services = [
  {
    id: "installatie",
    title: "Installatie Fitnessapparatuur",
    subtitle: "Professionele montage & opbouw",
    icon: "Wrench",
    image: "/service-installatie.webp",
    shortDescription: "Professionele installatie en montage van alle soorten fitnessapparatuur, van loopbanden tot complete krachtlijnen.",
    fullDescription: "Ons ervaren team installeert alle soorten fitnessapparatuur vakkundig en veilig. Van het uitpakken en monteren van loopbanden, crosstrainers en fitnesstoestellen tot het aansluiten van elektronische systemen en het afstellen van machines. Wij werken voor sportscholen, hotels, bedrijfsfitness en particulieren.",
    features: [
      "Montage en installatie van loopbanden & crosstrainers",
      "Opbouw van krachtstations en kabelmachines",
      "Plaatsen van cardio- en krachtapparatuur",
      "Aansluiting van elektronische displays en systemen",
      "Veiligheidscontrole en afstelling na installatie",
      "Installatie van complete gymruimtes van A tot Z"
    ],
    benefits: [
      "Vakkundig en ervaren team",
      "Veilige installatie volgens fabrieksvoorschriften",
      "Snelle doorlooptijd, minimale verstoring",
      "Garantie op montagewerk"
    ]
  },
  {
    id: "transport",
    title: "Transport Fitnessapparatuur",
    subtitle: "Nederland & Benelux",
    icon: "Truck",
    image: "/service-transport.webp",
    shortDescription: "Veilig en betrouwbaar transport van zware fitnessapparatuur door heel Nederland en de Benelux.",
    fullDescription: "Wij transporteren alle soorten fitnessapparatuur veilig en betrouwbaar. Van het ophalen bij de leverancier tot het afleveren op locatie. Onze voertuigen zijn speciaal uitgerust voor het vervoer van zware en kwetsbare apparatuur. Wij werken in heel Nederland, België en Duitsland.",
    features: [
      "Transport van zware fitnesstoestellen",
      "Ophalen bij leverancier of fabrikant",
      "Bezorging en plaatsing op locatie",
      "Verpakking en bescherming tijdens transport",
      "Expressleveringen mogelijk",
      "Track & trace op aanvraag"
    ],
    suitable: [
      "Sportscholen en fitnesscentra",
      "Hotels en resorts met fitnessruimte",
      "Bedrijfsfitness en kantoren",
      "Particulieren met thuisgym"
    ]
  },
  {
    id: "onderhoud",
    title: "Onderhoud & Verplaatsing",
    subtitle: "Service & nazorg",
    icon: "Package",
    image: "/service-onderhoud.webp",
    shortDescription: "Onderhoud, reparatie en verplaatsing van bestaande fitnessapparatuur op locatie.",
    fullDescription: "Naast installatie en transport bieden wij ook onderhoud en verplaatsingsdiensten aan. Verplaats uw gym naar een nieuwe locatie, laat apparatuur onderhouden of herplaats toestellen binnen uw ruimte. Wij zorgen ervoor dat alles weer perfect werkt.",
    features: [
      "Preventief onderhoud van fitnessapparatuur",
      "Verplaatsing van toestellen binnen de ruimte",
      "Demontage en hermontage bij verhuizing",
      "Herindeling van gymvloeren",
      "Inspectie en veiligheidscontrole",
      "Reparatie en vervanging van onderdelen"
    ],
    approach: [
      "Inspectie en inventarisatie",
      "Duidelijk plan en offerte vooraf",
      "Efficiënte uitvoering met minimale downtime",
      "Oplevering en functionele test"
    ]
  }
];

export const whyChooseUs = [
  {
    title: "Specialist in fitnessapparatuur",
    description: "Wij zijn gespecialiseerd in het installeren en transporteren van fitnessapparatuur. Van loopbanden tot complete krachtlijnen, wij kennen elk toestel."
  },
  {
    title: "Snel en flexibel inzetbaar",
    description: "Wij schakelen snel en passen ons aan uw planning aan. Spoedopdrachten zijn vaak dezelfde dag nog mogelijk."
  },
  {
    title: "Ervaren montageteam",
    description: "Ons team heeft jarenlange ervaring met het monteren en installeren van alle merken fitnessapparatuur."
  },
  {
    title: "Veiligheid voorop",
    description: "Elke installatie wordt afgerond met een volledige veiligheidscontrole en afstelling volgens fabrieksvoorschriften."
  },
  {
    title: "Nederland & Benelux",
    description: "Actief in heel Nederland, België en Duitsland. Geen afstand is ons te ver voor uw fitnessproject."
  },
  {
    title: "Alles-in-één service",
    description: "Van transport tot installatie en onderhoud, wij regelen alles rondom uw fitnessapparatuur onder één dak."
  }
];

export const workProcess = [
  {
    step: 1,
    title: "Aanvraag & inventarisatie",
    description: "Vertel ons welke apparatuur u wilt laten installeren of transporteren"
  },
  {
    step: 2,
    title: "Offerte & planning",
    description: "U ontvangt een duidelijke offerte en wij plannen de werkzaamheden in"
  },
  {
    step: 3,
    title: "Transport & installatie",
    description: "Ons team transporteert en installeert uw fitnessapparatuur vakkundig"
  },
  {
    step: 4,
    title: "Controle & oplevering",
    description: "Veiligheidscheck, afstelling en nette oplevering van alle apparatuur"
  }
];

export const serviceTypes = [
  { value: "Installatie", label: "Installatie" },
  { value: "Montage", label: "Montage" },
  { value: "Demontage", label: "Demontage" },
  { value: "Verhuizing", label: "Verhuizing" },
  { value: "Reparatie & service", label: "Reparatie & service" },
  { value: "Anders", label: "Anders" }
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Diensten", path: "/diensten" },
  { name: "Verhuizen", path: "/diensten/fitnessapparatuur-verhuizen" },
  { name: "Voor & Na", path: "/voor-en-na" },
  { name: "Blog", path: "/blog" },
  { name: "Reviews", path: "/reviews" },
  { name: "FAQ", path: "/faq" },
  { name: "Over ons", path: "/over-ons" },
  { name: "Contact", path: "/contact" }
];
